import type { StatsigEnvironments } from './types';

export const STATSIG_OVERRIDE_PARAM = 'overrideStatsig';

// Floating number, range from 0 to 100
// By default, there won't be any sampling for clients.
export const DEFAULT_SAMPLE_RATE = 100;

export const STATSIG_ENV: Record<string, StatsigEnvironments> = {
    PROD: 'production',
    QA: 'staging',
    DEV: 'development',
};

export const PROD_ENV_URLS_REGEX = /^(https?:\/\/)?(www.)?(eventbrite)/;
export const QA_ENV_URLS_REGEX = /^(https?:\/\/)?(www.)?(evbqa(\d)*).\w{2,}$/;
export const DEV_ENV_URL_REGEX = /^(https?:\/\/)?(dev.evbqa|www.evbdev|evbdev).com(:(\d)*)?\/?/;

// EDS Breakpoints: https://eventbrite.atlassian.net/wiki/spaces/FRONTEND/pages/15500640332/EDS+Breakpoints
export const SMALL_NARROW_WIDTH = 360;
export const SMALL_WIDTH = 480;
export const SMALL_WIDE_WIDTH = 660;
export const MEDIUM_NARROW_WIDTH = 792;
export const MEDIUM_WIDTH = 960;
export const MEDIUM_WIDE_WIDTH = 1080;
export const LARGE_NARROW_WIDTH = 1152;
export const LARGE_WIDTH = 1272;
export const LARGE_WIDE_WIDTH = 1608;
